import $ from 'jquery';
import { FireComponent } from '@base';

export class Cores extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $form: this.$component.find('[data-drupal-selector="views-exposed-form-cores-list"]'),
      $formCategorySelect: this.$component.find('[data-drupal-selector="edit-field-category-target-id"]'),
      $formDesignationSelect: this.$component.find('[data-drupal-selector="edit-field-designation-target-id"]'),
      $formSearchInput: this.$component.find('[data-drupal-selector="edit-search"]'),
      $filtersToggle: this.$component.find('[data-filters-toggle]'),
      $filters: this.$component.find('[data-filters]'),
      $filterCategory: this.$component.find('[data-filter-category]'),
      $filterDesignation: this.$component.find('[data-filter-designation]'),
      $filterSearch: this.$component.find('[data-filter-search]'),
      $filterSearchBtn: this.$component.find('[data-filter-search-btn]'),
      $clearFiltersBtn: this.$component.find('[data-filter-clear]'),
    };
  }

  _initCategorySelect() {
    if (this.elements.$formCategorySelect.length) {
      const options = this.elements.$formCategorySelect.get(0).children;
      [...options].map((option) => {
        this.elements.$filterCategory.get(0).innerHTML =
          this.elements.$filterCategory.get(0).innerHTML + `<option value="${option.value}">${option.innerText === '- Any -' ? 'All' : option.innerText}</option>`;
      });
    }
  }

  _initDesignationSelect() {
    if (this.elements.$formDesignationSelect.length) {
      const options = this.elements.$formDesignationSelect.get(0).children;
      [...options].map((option) => {
        this.elements.$filterDesignation.get(0).innerHTML =
          this.elements.$filterDesignation.get(0).innerHTML + `<option value="${option.value}">${option.innerText === '- Any -' ? 'All' : option.innerText}</option>`;
      });
    }
  }

  _filterBySearch() {
    if (this.elements.$filterSearch.length && this.elements.$filterSearchBtn.length) {
      const self = this;
      this.elements.$filterSearchBtn.get(0).addEventListener('click', function () {
        const searchValue = self.elements.$filterSearch.get(0).value;
        self.elements.$formSearchInput.get(0).value = searchValue;
        self._submitForm();
      });
    }
  }

  _filterByCategory() {
    if (this.elements.$filterCategory.length) {
      const self = this;
      this.elements.$filterCategory.get(0).addEventListener('change', function () {
        const categoryValue = self.elements.$filterCategory.get(0).value;
        self.elements.$formCategorySelect.get(0).value = categoryValue;
        self._submitForm();
      });
    }
  }

  _filterByDesignation() {
    if (this.elements.$filterDesignation.length) {
      const self = this;
      this.elements.$filterDesignation.get(0).addEventListener('change', function () {
        const designationValue = self.elements.$filterDesignation.get(0).value;
        self.elements.$formDesignationSelect.get(0).value = designationValue;
        self._submitForm();
      });
    }
  }

  _isFiltered() {
    if (this.elements.$formSearchInput.get(0).value === '' && this.elements.$formCategorySelect.get(0).value === 'All' && this.elements.$formDesignationSelect.get(0).value === 'All') {
      this._showClearButton(false);
    } else {
      this._showClearButton(true);
    }
  }

  _showClearButton(show = true) {
    if (show) {
      this.elements.$clearFiltersBtn.get(0).classList.remove('hidden');
    } else {
      this.elements.$clearFiltersBtn.get(0).classList.add('hidden');
    }
  }

  _clearForm() {
    const self = this;
    this.elements.$clearFiltersBtn.get(0).addEventListener('click', function () {
      //create element for screen readers to announce filters were cleared
      //then remove after it's announced.
      let alert = document.createElement('div');
      alert.setAttribute('role', 'alert');
      alert.setAttribute('aria-live', 'polite');
      alert.classList.add('sr-only');
      self.$component.get(0).appendChild(alert);
      alert.innerText = 'Filter cleared successfully.';
      setTimeout(() => {
        alert.remove();
      }, 2000);

      self.elements.$filterSearch.get(0).value = '';
      self.elements.$formSearchInput.get(0).value = '';

      self.elements.$filterCategory.get(0).value = 'All';
      self.elements.$formCategorySelect.get(0).value = 'All';

      self.elements.$filterDesignation.get(0).value = 'All';
      self.elements.$formDesignationSelect.get(0).value = 'All';

      self._submitForm();
    });
  }

  _submitForm() {
    this._isFiltered();
    const submitButton = this.elements.$form.get(0).querySelector('input[type="submit"]');
    submitButton.click();
  }

  _toggleFilterView() {
    this.elements.$filtersToggle.get(0).setAttribute('aria-expanded', 'true');
    if (!window.matchMedia('(min-width: 960px').matches) {
      const self = this;
      this.elements.$filtersToggle.get(0).setAttribute('aria-expanded', 'false');
      this.elements.$filtersToggle.get(0).addEventListener('click', function () {
        if (self.elements.$filtersToggle.get(0).getAttribute('aria-expanded') === 'true') {
          self.elements.$filtersToggle.get(0).setAttribute('aria-expanded', 'false');
        } else {
          self.elements.$filtersToggle.get(0).setAttribute('aria-expanded', 'true');
        }
      });
    }
  }

  init() {
    if (this.componentExists) {
      this._initCategorySelect();
      this._initDesignationSelect();
      this._filterBySearch();
      this._filterByCategory();
      this._filterByDesignation();
      this._clearForm();
      this._toggleFilterView();

      var self = this;
      $(window).on('resize', function () {
        self._toggleFilterView();
      });
    }
  }
}
